import { plainObjectFromValue, promoteKey } from "web/services/helpers"

// colours from Tailwind palette
export const mapPinColours = [
  "#059669", // green 600
  "#F87171", // red 400
  "#FACC15", // yellow 400
  "#A78BFA", // purple 400
  "#F472B6", // pink 400
  "#38BDF8", // light blue 400
  "#65A30D", // lime 600
  "#D97706", // amber 600
]

export const defaultPinColour = "#3B82F6" // red 500

export function getMapBoxSafeValues(values) {
  const plainObject = plainObjectFromValue(promoteKey(values, "value"))

  Object.keys(plainObject).forEach((key) => {
    if (typeof plainObject[key] === "boolean") {
      plainObject[key] = plainObject[key] ? "true" : "false"
    }
  })

  return plainObject
}
